import { ActionTypes } from "../contants/action-type";

const initialState = {
    ingredients: [],
    ingredient: {}
}

export const IngredientReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.LIST_INGREDIENT:
            return {...state, ingredients: payload};
        case ActionTypes.SELECTED_INGREDIENT:
            return {...state, ingredient: payload};
        case ActionTypes.CONFIRM_CREATE_INGREDIENT:
            return {...state, ingredient: payload};
        case ActionTypes.CONFIRM_DELETE_INGREDIENT:
            return {...state, ingredients: payload};
        default:
            return state;
    }
}